import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "loren-automation-plan-section",
    imports: [],
    templateUrl: "./loren-automation-plan-section.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./loren-automation-plan-section.component.scss"
})
export class LorenAutomationPlanSectionComponent {
  @Input() number: number;
  @Input() title: string;
  @Input() subtitle: string;
}
